import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { checkAuth } from '../../store/slices/authSlice';
import { Spinner } from '../common/Spinner';

/**
 * PrivateRoute component that protects routes requiring authentication
 * Redirects to /login if user is not authenticated
 */
export const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, loading } = useSelector(state => state.auth);
  const [checking, setChecking] = React.useState(true);

  useEffect(() => {
    const verifyAuth = async () => {
      if (!isAuthenticated) {
        // Try to restore session from localStorage
        await dispatch(checkAuth());
      }
      setChecking(false);
    };

    verifyAuth();
  }, [dispatch, isAuthenticated]);

  // Show loading spinner while checking authentication
  if (checking || loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <Spinner size="lg" />
          <p className="text-slate-600 mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render protected content
  return children;
};
